<icc-list [searchable]="true" [items]="glazingSpacers"
          [itemTemplate]="'itemImgTitle'"
          [selected]="selectedSpacerId"
          itemImgHeight="medium"
          (select)="selectSpacer($event)"></icc-list>
